<template>
	<div id="uploadcobmit">
	   <!-- <div id="top">
      
   <header-box title='上传名单'></header-box>    
   
    </div> -->
<div class="whitebox">
			<div class="cobmitTimg">
			<img src="../../assets/succees.png" />
		</div>
		<div class="cobmitTrue">
			 
			 
			<span class="cobmitwz">提交成功!</span>
	 
		</div>
		<div class="cobmithui">
		<p>可到「机构服务」-「批量约考」中查看考生信息并进行二次确认。</p>
		</div>
		<br/>
		<van-form>
		<div style="margin: 16px; display: flex">
		<van-button 
		class="left"
		type="primary" 
		size="normal" 
		style="width: 109px; border: 1px solid rgba(89,176,246); background-color: white;"
		@click="gohome()">
      <span style="color: rgba(89,176,246);" >返回首页</span>
    </van-button>
    <van-button 
	type="primary" 
	size="normal" 
	style="width: 109px; background-color: rgb(89,176,246);margin-left: 20px;"
	@click="ontrue()">
      前往查看

    </van-button>
  </div>
  </van-form>
</div>
	</div>
</template>

<script>
import headerBox from '@/components/header.vue'
export default {
  components:{
headerBox,
  },
  data() {
	return {
	  active: 0,
	  TimeShow: false,
	  PlaceShow: false,
	  radio: ''
	};
  },
  methods:{
	
	gohome(){
		this.$router.push({path:'/index'});
		//console.log(123)
	},
	ontrue(){
		this.$router.push({path:'/examore'});
	}
  }
//   components: {
// 	Select
//   },
};
</script>

<style lang='less' scoped>
	#uploadcobmit{
		font-family: "Avenir", Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		font-size: 32px;
		/* padding-top: 60px;
		margin-left: 400px; */
		width: 100%;
		height: 100%;
		background-color: rgb(240,240,240);
	
		.whitebox{
	background-color: @whitee;
			height: 522px;
			.cobmitTimg{
				padding: @paddingpay 0;
			display: flex;
    justify-content: center;
	img{
		width: 108px;
	}
		}
		.cobmitTrue{
          text-align: center;  
		  font-size: @paddingpay;
		}
		.cobmitwz{
			font-size: 28px;
		}
		.cobmithui{
		 text-align: center;  
		 color: rgb(173,173,173);
		 font-size: 22px;
		 margin-top: @checkringht;

		}

		}
		
	}
#top {
  text-align: center;
 height: 176px;
 box-sizing: border-box;
  padding-top: 125px;
  background-color:@backgroundcolor;
  padding-bottom: 69px;
}
.left{
	margin-left: 120px;
}
</style>
